import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  ICiudad,
  IComuna,
  IDatosContratanteProducto,
  IRegion,
} from 'src/app/shared/Entities/entities';
import {
  validatePhone,
  validateEmail,
} from 'src/app/shared/helpers/customValidators';
import { formateaRut } from 'src/app/shared/helpers/helper';
import { getErrorMessage } from 'src/app/shared/helpers/validationMessages';
import { PersonService } from 'src/app/shared/services/person.service';
import { UbicationService } from 'src/app/shared/services/ubication.service';
import { EventsService } from '../../services/events.service';
import { MatDialog } from '@angular/material';
import { DialogMessageModalComponent } from '../dialog-message-modal/dialog-message-modal.component';
import { statusEnum } from '../../helpers/constants';
import { AppInsightsService } from '../../services/app-insights-service';
import { Event } from '../../enums/insights/event';

@Component({
  selector: 'app-card-datos-contratante-producto',
  templateUrl: './card-datos-contratante-producto.component.html',
  styleUrls: ['./card-datos-contratante-producto.component.sass'],
})
export class CardDatosContratanteProductoComponent
  implements OnInit, OnDestroy {
  datoContratante: IDatosContratanteProducto;
  editMode = false;
  loading = false;
  error = false;
  getErrorMessage = getErrorMessage;
  @Input() idPoliza: string;
  @Input() tabActive: boolean;
  @Input() tipoSeguro = '';
  @Input() lineaNegocio = '';
  @Input() expanded = true;
  @Input() info: string;
  @Input() mostrarInfo = false;
  @Output() getDatosContratante$ = new EventEmitter();
  @Output() getPrintData$ = new EventEmitter();

  form: FormGroup;
  regiones: IRegion[] = [];
  comunas: IComuna[] = [];
  comunasComerc: IComuna[] = [];
  comunasCorres: IComuna[] = [];
  ciudades: ICiudad[] = [];
  ciudadesComerc: ICiudad[] = [];
  ciudadesCorres: ICiudad[] = [];

  private subscriptions: Subscription[] = [];

  // private dataSubs: Subscription;
  constructor(
    private personService: PersonService,
    private formBuilder: FormBuilder,
    private ubicationService: UbicationService,
    private eventSrv: EventsService,
    public dialog: MatDialog,
    private appInsightsService: AppInsightsService
  ) {
    this.eventSrv.recargarBenef$.subscribe(data => {
      if (!data) {
        return;
      }
      this.ngOnInit();
    });

    this.form = this.formBuilder.group({
      Celular: ['', { validators: [Validators.required, validatePhone] }],
      TelefonoComercial: ['', [validatePhone]],
      Direccion: ['', [Validators.maxLength(100)]],

      Correo: ['', [Validators.required, validateEmail]],
      CodigoRegion: [''],
      CodigoCiudad: [''],
      CodigoComuna: [''],

      CodigoRegionComerc: [''],
      CodigoCiudadComerc: [''],
      CodigoComunaComerc: [''],
      DireccionComercial: ['', [Validators.maxLength(100)]],

      CodigoRegionCorres: ['', [Validators.required]],
      CodigoCiudadCorres: ['', [Validators.required]],
      CodigoComunaCorres: ['', [Validators.required]],
      DireccionCorres: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }

  ngOnInit() {
    this.loadRegion();
    this.loadData();
  }

  onEditMode() {
    this.appInsightsService.trackEvent(Event.iidsBtnModifyData);
    this.editMode = true;
  }

  loadRegion() {
    this.ubicationService.getRegiones().subscribe(regiones => {
      this.regiones = regiones;
    });
  }

  getNombreRegionByCodigo(code: string, dirType: string) {
    if (!code || !this.regiones) {
      return '-';
    }
    const element = this.regiones.find(x => x.CodigoRegion === code);
    switch (dirType) {
      case 'direccion':
        this.datoContratante.Region = element ? element.Nombre : '-';
        break;
      case 'direccionComerc':
        this.datoContratante.regionComerc = element ? element.Nombre : '-';
        break;
      case 'direccionCorres':
        this.datoContratante.regionCorres = element ? element.Nombre : '-';
        break;
    }
    this.sendPrintData();
    return element ? element.Nombre : '';
  }

  getNombreCuidadByCodigo(code: string, dirType: string) {
    let element = {} as ICiudad;
    switch (dirType) {
      case 'direccion':
        if (!code || !this.ciudades) {
          return '-';
        }
        element = this.ciudades.find(x => x.CodigoCiudad === code);
        this.datoContratante.Ciudad = element ? element.Nombre : '-';
        break;
      case 'direccionComerc':
        if (!code || !this.ciudadesComerc) {
          return '-';
        }
        element = this.ciudadesComerc.find(x => x.CodigoCiudad === code);
        this.datoContratante.ciudadComerc = element ? element.Nombre : '-';
        break;
      case 'direccionCorres':
        if (!code || !this.ciudadesCorres) {
          return '-';
        }
        element = this.ciudadesCorres.find(x => x.CodigoCiudad === code);
        this.datoContratante.ciudadCorres = element ? element.Nombre : '-';
        break;
      default:
        element.Nombre = '';
        break;
    }

    this.sendPrintData();
    return element ? element.Nombre : '';
  }

  getNombreComunaByCodigo(code: string, dirType: string) {
    let element = {} as IComuna;
    switch (dirType) {
      case 'direccion':
        if (!code || !this.comunas) {
          return '-';
        }
        element = this.comunas.find(x => x.CodigoComuna === code);
        this.datoContratante.Comuna = element ? element.Nombre : '-';

        break;
      case 'direccionComerc':
        if (!code || !this.comunasComerc) {
          return '-';
        }
        element = this.comunasComerc.find(x => x.CodigoComuna === code);
        this.datoContratante.comunaComerc = element ? element.Nombre : '-';
        break;
      case 'direccionCorres':
        if (!code || !this.comunasCorres) {
          return '-';
        }
        element = this.comunasCorres.find(x => x.CodigoComuna === code);
        this.datoContratante.comunaCorres = element ? element.Nombre : '-';
        break;
      default:
        element.Nombre = '';
        break;
    }

    this.sendPrintData();
    return element ? element.Nombre : '';
  }

  loadData() {
    this.loading = true;
    this.error = false;
    const dataSubs = this.personService
      .getDatosContratanteProducto(
        this.idPoliza,
        this.lineaNegocio,
        this.tipoSeguro
      )
      .subscribe(
        data => {
          this.loading = false;
          this.datoContratante = data;
          this.sendPrintData();
          this.getDatosContratante$.emit(this.datoContratante);
          if (this.datoContratante) {
            this.getCiudadesByRegion(this.datoContratante.CodigoRegion);
            this.getCiudadesByRegionComerc(
              this.datoContratante.CodigoRegionComerc
            );
            this.getCiudadesByRegionCorres(
              this.datoContratante.CodigoRegionCorres
            );
            this.form = this.formBuilder.group({
              Celular: [
                this.datoContratante.Celular,
                { validators: [Validators.required, validatePhone] },
              ],
              TelefonoComercial: [
                this.datoContratante.TelefonoComercial,
                [validatePhone],
              ],
              Direccion: [
                this.datoContratante.Direccion,
                [Validators.maxLength(100)],
              ],
              Correo: [
                this.datoContratante.Correo,
                [Validators.required, validateEmail],
              ],
              CodigoRegion: [this.datoContratante.CodigoRegion],
              CodigoCiudad: [this.datoContratante.CodigoCiudad],
              CodigoComuna: [this.datoContratante.CodigoComuna],

              CodigoComunaComerc: [this.datoContratante.CodigoComunaComerc],
              CodigoCiudadComerc: [this.datoContratante.CodigoCiudadComerc],
              CodigoRegionComerc: [this.datoContratante.CodigoRegionComerc],
              DireccionComercial: [
                this.datoContratante.DireccionComercial,
                [Validators.maxLength(100)],
              ],

              CodigoComunaCorres: [
                this.datoContratante.CodigoComunaCorres,
                [Validators.required],
              ],
              CodigoCiudadCorres: [
                this.datoContratante.CodigoCiudadCorres,
                [Validators.required],
              ],
              CodigoRegionCorres: [
                this.datoContratante.CodigoRegionCorres,
                [Validators.required],
              ],
              DireccionCorres: [
                this.datoContratante.DireccionCorres,
                [Validators.required, Validators.maxLength(100)],
              ],
            });
            for (const i in this.form.controls) {
              if (i) {
                this.form.controls[i].markAsTouched();
              }
            }
          }

          // this.form.markAsTouched({ onlySelf: false });
          // this.form.controls[].updateValueAndValidity();
        },
        error => {
          this.loading = false;
          this.error = true;
        }
      );

    this.subscriptions.push(dataSubs);
  }

  offEditMode() {
    this.editMode = false;
    this.loadData();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  regionOnChangeComerc(event) {
    if (!event) {
      return;
    }
    this.getCiudadesByRegionComerc(event.value);
  }

  getCiudadesByRegionComerc(region) {
    this.ubicationService.getCiudades(region).subscribe(ciudades => {
      if (!ciudades) {
        return;
      }
      this.ciudadesComerc = ciudades.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // this.comunas = [];
      if (this.editMode) {
        this.form.patchValue(
          {
            CodigoCiudadComerc: null,
            CodigoComunaComerc: null,
          },
          { onlySelf: true, emitEvent: false }
        );
      } else {
        this.ciudadOnChangeComerc({
          value: this.datoContratante.CodigoCiudadComerc,
        });
      }
    });
  }

  ciudadOnChangeComerc(event) {
    if (!event) {
      return;
    }
    this.ubicationService.getComunas(event.value).subscribe(comunas => {
      this.comunasComerc = comunas.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
    if (this.editMode) {
      this.form.patchValue(
        {
          CodigoComunaComerc: null,
        },
        { onlySelf: true, emitEvent: false }
      );
    }
  }

  regionOnChangeCorres(event) {
    if (!event) {
      return;
    }
    this.getCiudadesByRegionCorres(event.value);
  }

  getCiudadesByRegionCorres(region) {
    this.ubicationService.getCiudades(region).subscribe(ciudades => {
      this.ciudadesCorres = ciudades.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // this.comunas = [];
      if (this.editMode) {
        this.form.patchValue(
          {
            CodigoCiudadCorres: null,
            CodigoComunaCorres: null,
          },
          { onlySelf: true, emitEvent: false }
        );
      } else {
        this.ciudadOnChangeCorres({
          value: this.datoContratante.CodigoCiudadCorres,
        });
      }
    });
  }

  ciudadOnChangeCorres(event) {
    if (!event) {
      return;
    }
    this.ubicationService.getComunas(event.value).subscribe(comunas => {
      this.comunasCorres = comunas.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
    if (this.editMode) {
      this.form.patchValue(
        {
          CodigoComunaCorres: null,
        },
        { onlySelf: true, emitEvent: false }
      );
    }
  }

  regionOnChange(event) {
    if (!event) {
      return;
    }
    this.getCiudadesByRegion(event.value);
  }

  getCiudadesByRegion(region) {
    this.ubicationService.getCiudades(region).subscribe(ciudades => {
      this.ciudades = ciudades.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // this.comunas = [];
      if (this.editMode) {
        this.form.patchValue(
          {
            CodigoCiudad: null,
            CodigoComuna: null,
          },
          { onlySelf: true, emitEvent: false }
        );
      } else {
        this.ciudadOnChange({ value: this.datoContratante.CodigoCiudad });
      }
    });
  }

  ciudadOnChange(event) {
    if (!event) {
      return;
    }
    this.ubicationService.getComunas(event.value).subscribe(comunas => {
      this.comunas = comunas.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
    if (this.editMode) {
      this.form.patchValue(
        {
          CodigoComuna: null,
        },
        { onlySelf: true, emitEvent: false }
      );
    }
  }

  save() {
    if (!this.form.valid || !this.form.dirty) {
      return;
    }

    this.appInsightsService.trackEvent(Event.iidsBtnSaveModifyData);
    const data: IDatosContratanteProducto = {
      ...this.datoContratante,
      ...this.form.value,
    };

    this.personService
      .postContratanteProducto(data, this.idPoliza, this.lineaNegocio)
      .subscribe(
        res => {
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'DATOS GUARDADOS',
              message: 'Datos guardados correctamente.',
              type: statusEnum.success,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
          this.loadData();
          this.editMode = false;
        },
        error => {
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'HA OCURRIDO UN PROBLEMA',
              message: 'Favor inténtelo más tarde.',
              type: statusEnum.error,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
        }
      );
  }

  formatRUT(rut: string) {
    return formateaRut(rut);
  }

  getFullName() {
    if (!this.datoContratante) {
      return '';
    }

    return `${this.datoContratante.Nombre ? this.datoContratante.Nombre : ''} ${
      this.datoContratante.ApellidoPaterno
        ? this.datoContratante.ApellidoPaterno
        : ''
    } ${
      this.datoContratante.ApellidoMaterno
        ? this.datoContratante.ApellidoMaterno
        : ''
    }`;
  }

  print() {
    if (this.error || !this.datoContratante) {
      return null;
    }
    return [
      {
        type: 'title',
        content: {
          text: `DATOS DEL CONTRATANTE ${this.getFullName()}`,
          halign: 'left',
        },
      },
      {
        type: 'table-resumen',
        width: 100,
        content: {
          size: {
            columns: [33, 33, 33],
          },
          table: [
            [
              {
                value: this.datoContratante.Celular,
                header: 'Teléfono particular',
                type: 'header',
              },
              {
                header: 'Teléfono comercial',
                type: 'header',
                value: this.datoContratante.TelefonoComercial,
              },

              {
                header: 'Correo electrónico',
                type: 'header',
                value: this.datoContratante.Correo,
              },
            ],
            [
              {
                header: 'Dirección Particular',
                type: 'header',
                value: `${
                  this.datoContratante.Direccion
                    ? this.datoContratante.Direccion
                    : '-'
                },
                ${
                  this.datoContratante.Ciudad
                    ? this.datoContratante.Ciudad
                    : '-'
                }
                , ${
                  this.datoContratante.Comuna
                    ? this.datoContratante.Comuna
                    : '-'
                },
                ${
                  this.datoContratante.Region
                    ? this.datoContratante.Region
                    : '-'
                }`,
              },
              {
                header: 'Dirección Comercial',
                type: 'header',
                value: `${
                  this.datoContratante.DireccionComercial
                    ? this.datoContratante.DireccionComercial
                    : '-'
                },
                ${
                  this.datoContratante.ciudadComerc
                    ? this.datoContratante.ciudadComerc
                    : '-'
                },
                ${
                  this.datoContratante.comunaComerc
                    ? this.datoContratante.comunaComerc
                    : '-'
                },
                ${
                  this.datoContratante.regionComerc
                    ? this.datoContratante.regionComerc
                    : '-'
                }`,
              },

              {
                header: 'Dirección Envío Correspondencia',
                type: 'header',
                value: `${
                  this.datoContratante.DireccionCorres
                    ? this.datoContratante.DireccionCorres
                    : '-'
                },
                ${
                  this.datoContratante.ciudadCorres
                    ? this.datoContratante.ciudadCorres
                    : '-'
                },
                ${
                  this.datoContratante.comunaCorres
                    ? this.datoContratante.comunaCorres
                    : '-'
                },
                ${
                  this.datoContratante.regionCorres
                    ? this.datoContratante.regionCorres
                    : '-'
                }`,
              },
            ],
          ],
        },
      },
    ];
  }

  sendPrintData() {
    if (this.tabActive) {
      this.getPrintData$.emit(this.print());
    }
  }

  expandChange() {
    this.appInsightsService.trackEvent(Event.iidsAccShowContractor);
  }
}
